<div class="number-range-container row">
  <div class="number-range-numbers col-md-12">
      {{numberRange.range}}

  </div>
  <div class="number-range-location col-md-12">
    {{numberRange.location}}
  </div>
</div>